import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 16,
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16,
    overflowY: 'auto'
  },
  listContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 20,
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: '1fr 1fr'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }
}))

export default useStyles
